
define('template!modalFooterView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="left">\n  <div class="loader-2"></div>\n</div>\n<div class="right">\n    <div class="cancel-region"></div>\n    <div class="confirm-region"></div>\n</div>';

}
return __p
};});

